import { render, staticRenderFns } from "./SearchResultDownload.vue?vue&type=template&id=368d1e9a&scoped=true&"
import script from "./SearchResultDownload.vue?vue&type=script&lang=js&"
export * from "./SearchResultDownload.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultDownload.vue?vue&type=style&index=0&id=368d1e9a&prod&lang=scss&"
import style1 from "./SearchResultDownload.vue?vue&type=style&index=1&id=368d1e9a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368d1e9a",
  null
  
)

export default component.exports